import PropTypes from 'prop-types';
import React from 'react';

const PageNavComponent = function ({ currentPage, totalPage, onChangePage }) {
  const upperbound = Math.min(Math.max(10, currentPage + 4), totalPage);
  const lowerbound = Math.max(1, upperbound - 9);
  const pages = [];
  if (currentPage > 1) {
    pages.push(
      <li key="firstpage" className="active" onClick={() => onChangePage(1)} role="presentation">
        First
      </li>,
    );
    pages.push(
      <li key="prevpage" className="active" onClick={() => onChangePage(currentPage - 1)} role="presentation">
        Previous
      </li>,
    );
  } else {
    pages.push(<li key="firstpage">First</li>);
    pages.push(<li key="prevpage">Previous</li>);
  }
  if (lowerbound > 1) {
    pages.push(<li key="lodot">...</li>);
  }
  for (let navPage = lowerbound; navPage <= upperbound; navPage++) {
    pages.push(
      navPage === currentPage ? (
        <li key={navPage} className="current">
          {navPage}
        </li>
      ) : (
        <li key={navPage} className="active" onClick={() => onChangePage(navPage)} role="presentation">
          {navPage}
        </li>
      ),
    );
  }
  if (upperbound < totalPage) {
    pages.push(<li key="hidot">...</li>);
  }
  if (currentPage < totalPage) {
    pages.push(
      <li key="nextpage" className="active" onClick={() => onChangePage(currentPage + 1)} role="presentation">
        Next
      </li>,
    );
    pages.push(
      <li key="lastpage" className="active" onClick={() => onChangePage(totalPage)} role="presentation">
        Last
      </li>,
    );
  } else {
    pages.push(<li key="nextpage">Next</li>);
    pages.push(<li key="lastpage">Last</li>);
  }
  return <ul>{pages}</ul>;
};

PageNavComponent.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
};

export default PageNavComponent;
